import React, { useMemo, useState } from 'react';
import { Box, Checkbox, InputBase, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { i18n } from '../../../../language';
import DiaLog from '../../../../components/Dialog';
import { classNames, escapeHtmlKeepUrls, getArrayRandomKey } from '../../../../utils';
import templateIcon from '../../../../static/images/template.png';
import { getSendToDisplayName } from '../../../../utils/eHandoverUtil';

const useStyles = makeStyles((theme) => ({
  templateLabel: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    marginBottom: '1.428rem',
    color: '#7D86A9',
  },
  temContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1.428rem',
    flexWrap: 'wrap',
  },
  templateBox: {
    minWidth: '20.714rem',
    borderRadius: '16px',
    border: '2px solid #E4E7EB',
    padding: '1.142rem 1.428rem',
    display: 'flex',
    flexDirection: 'row',
    gap: '1.142rem',
    alignItems: 'center',
    cursor: 'pointer',
  },
  selectedTemplate: {
    border: '2px solid #538FFF',
    backgroundColor: '#EEF4FF',
  },
  templateIcon: {
    width: '2.2rem',
    height: '3.27rem',
  },
  textWrapper: {
    overflow: 'hidden',
    flex: 1,
  },
  templateName: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.142rem',
    fontWeight: '700',
    // overflow: 'hidden',
    // textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  defaultText: { fontFamily: 'NotoSans-Medium', fontSize: '1rem', fontWeight: '500', color: '#7D86A9' },
  checkBox: {
    '& .MuiSvgIcon-root': {
      height: '2rem',
      width: '2rem',
    },
    '&.MuiCheckbox-colorSecondary.Mui-checked': {
      color: theme.palette.status.green,
      borderRadius: '0.315rem',
    },
    '&.MuiCheckbox-root': {
      color: '#c0c6cb',
    },
  },
  inputBox: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    border: '0.0625rem solid #C0C6CB',
    borderRadius: '0.625rem',
    padding: '0 0 0 1.25rem',
  },
  input: {
    fontSize: '1.125rem',
    color: theme.palette.font.main,
    fontWeight: '500',
  },
  checListBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.142rem',
  },
  tagsLabel: {
    color: '#2e4469',
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: 'NotoSans-Medium',
  },
  tagsBox: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  tagicon: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.75rem',
    textAlign: 'center',
    letterSpacing: '0.013rem',
    color: theme.palette.font.white,
    fontWeight: '600',
    backgroundColor: '#979bff',
    height: '1.536rem',
    display: 'flex',
    alignItems: 'center',
    padding: '0 0.5rem',
    borderRadius: '0.25rem',
  },
  confitmContent: {
    fontSize: '1.142rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: 500,
    marginBottom: '1.2rem',
  },
  context: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.142rem',
    lineHeight: '1.625rem',
    color: theme.palette.font.main,
    fontWeight: '500',
    wordWrap: 'break-word',
    whiteSpace: 'pre-line',
    wordBreak: 'normal',
    marginBottom: '1.428rem',
    '&>a': {
      display: 'inline-flex',
      fontSize: '1rem',
      color: '#538fff',
      fontFamily: 'NotoSans-Medium',
      lineHeight: 0,
    },
  },
  sendTo: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    letterSpacing: '0.0218rem',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    color: '#7d86a9',
  },
}));

export default function UseTemplateDialog({
  open,
  closePop,
  templateList,
  handleApplyTaskTemplate,
  isDirty,
  individualUsers,
}) {
  const classes = useStyles();
  const [selected, setSelected] = useState(null);
  const [showComfirmDialog, setShowComfirmDialog] = useState(false);

  const showCheckList = useMemo(() => {
    return Array.isArray(selected?.checkLists) && selected?.checkLists?.length > 0;
  }, [selected?.checkLists]);
  const showTagList = useMemo(() => {
    return Array.isArray(selected?.tags) && selected?.tags?.length > 0;
  }, [selected?.tags]);

  const sendToDisplayName = useMemo(() => {
    const sendToRoomType = _.map(selected?.sendToList?.roomTypeList, (item) => item?.value);
    return getSendToDisplayName({
      individualUsers,
      sendToRoomType,
      sendToCorp: selected?.sendToList?.staffList,
    });
  }, [selected, individualUsers]);

  const TemplateItem = ({ templateItem }) => {
    return (
      <Box
        className={classNames(classes.templateBox, selected?.id === templateItem?.id && classes.selectedTemplate)}
        onClick={() => setSelected(templateItem)}
      >
        <img className={classes.templateIcon} src={templateIcon} alt="template icon" />
        <Box className={classes.textWrapper}>
          <Box className={classes.templateName}>{templateItem?.templateName}</Box>
          {/* <Box className={classes.defaultText}>{i18n.t('EHANDOVER_DEFAULT')}</Box> */}
        </Box>
      </Box>
    );
  };
  const PreviewCheckList = ({ index, text, checked }) => {
    return (
      <Box display="flex" flexDirection="row">
        <Checkbox checked={checked} className={classes.checkBox} disabled />
        <Box className={classes.inputBox}>
          <InputBase
            id={`note-preview-checklist-${index}`}
            className={classes.input}
            fullWidth
            autoFocus
            disabled
            value={text}
          />
        </Box>
      </Box>
    );
  };
  const handleConfirm = () => {
    _.isFunction(handleApplyTaskTemplate) && handleApplyTaskTemplate(selected);
    closePop();
    setShowComfirmDialog(false);
  };
  const handleApply = () => {
    if (isDirty) {
      setShowComfirmDialog(true);
      return;
    }
    handleConfirm();
  };

  return (
    <>
      <DiaLog
        handleClose={closePop}
        handleCancel={closePop}
        title={i18n.t('EHANDOVER_USE_TEMPLATE')}
        cancel={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_CANCEL')}
        confirm={i18n.t('EHANDOVER_APPLY')}
        handleConfirm={handleApply}
        dialogfootStyle={{ marginTop: '1rem' }}
        open={open}
        width="100%"
        dialogWidth="70%"
        dialogContentStyle={{ overflowY: 'auto' }}
        disabled={!selected}
        isCapitalize={false}
      >
        <Box mb="2rem">
          <Box className={classes.templateLabel}>{i18n.t('EHANDOVER_CHOOSE_TEMPLATE')}</Box>
          <Box className={classes.temContainer}>
            {templateList.map((templateItem, index) => (
              <TemplateItem key={getArrayRandomKey(index, 'notes-template')} templateItem={templateItem} />
            ))}
          </Box>
        </Box>
        {selected && (
          <Box>
            <Box fontSize="1.714rem" fontFamily="NotoSans-Medium" fontWeight="bold" mb="1rem">
              {i18n.t('EHANDOVER_PREVIEW')}
            </Box>

            {Boolean(selected?.description) && (
              <div
                className={classes.context}
                dangerouslySetInnerHTML={{
                  __html: escapeHtmlKeepUrls(selected?.description),
                }}
              />
            )}

            <Box display="flex" flexDirection="column" gridGap="1rem">
              {showCheckList && (
                <Box className={classes.checListBox}>
                  {selected?.checkLists.map((item, index) => {
                    return (
                      <PreviewCheckList
                        key={getArrayRandomKey(index, `checklist-preview-${item?.sortIndex}`)}
                        text={item.title}
                        index={item?.sortIndex}
                        checked={item?.isComplete}
                      />
                    );
                  })}
                </Box>
              )}

              {showTagList && (
                <Box display="flex" flexDirection="row" gridGap="0.857rem" alignItems="center">
                  <Box className={classes.tagsLabel}>{i18n.t('EHANDOVER_NOTE_TAG')}</Box>
                  <Box className={classes.tagsBox}>
                    {selected?.tags.map((tag, index) => (
                      <Box className={classes.tagicon} key={getArrayRandomKey(index, `note-preview-tag-${tag.id}`)}>
                        {tag.tagDesc}
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {sendToDisplayName && (
                <Box display="flex" alignItems="center" flexWrap="wrap">
                  <div className={classes.sendTo}>
                    {`${i18n.t('EHANDOVER_SEND_TO')}:`}&nbsp;{sendToDisplayName}
                  </div>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </DiaLog>
      {showComfirmDialog && (
        <DiaLog
          handleClose={() => setShowComfirmDialog(false)}
          handleCancel={() => setShowComfirmDialog(false)}
          title={i18n.t('EHANDOVER_APPLICATION_CONFIRMATION')}
          cancel={i18n.t('EQUIPMENT_VIEWREQUEST_NEW_REQUEST_CANCEL')}
          confirm={i18n.t('EHANDOVER_TASKITEM_CONFIRM')}
          handleConfirm={handleConfirm}
          dialogfootStyle={{ marginTop: '1rem' }}
          open={showComfirmDialog}
          width="100%"
          // dialogWidth="50%"
          dialogContentStyle={{ overflowY: 'auto' }}
        >
          <Box className={classes.confitmContent}>{i18n.t('EHANDOVER_APPLICATION_CONFIRMATION_CONTENT')}</Box>
        </DiaLog>
      )}
    </>
  );
}
